// extracted by mini-css-extract-plugin
export default {"contain":"ProjectCard_contain__ohnVB","image":"ProjectCard_image__XCjnm","overlay":"ProjectCard_overlay__h1hHe","text":"ProjectCard_text__E4Sro"};